import React, { useState } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import teethImplantation from '../../assets/images/Teeth implantation.jpeg';
import cosmeticDentalTreatment from '../../assets/images/Services/COSMETIC DENTSL TREATMENT.jpeg';
import endodonticTreatment from '../../assets/images/Services/ENDODONTIC NERVE AND ROOT CANAL TREATMENT.jpeg';
import prosthesesInstallation from '../../assets/images/Services/INSTALLATION OF PROSTHESES.jpeg';
import pediatricServices from '../../assets/images/Services/PEDIATRIC DENTAL SERVICES.jpeg';
import TherapeuticAndCosmetic from '../../assets/images/Services/THERAPEUTIC AND COSMATIC.jpeg';
import therapeuticOrthodontics from '../../assets/images/Services/THERAPEUTIC ORTHODONTICS.jpeg';

const ServicesSection = styled.section`
  padding: 80px 0;
  background-color: #fff;
`;

const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
`;

const ServicesTitle = styled.h2`
  font-size: 64px;
  font-weight: bold;
  margin-bottom: 40px;
  text-align: ${props => props.$dir === 'rtl' ? 'right' : 'left'};
  padding-bottom: 20px;
  border-bottom: 1px solid #e0e0e0;
  
  .our-text {
    color: #3858F9;
  }
  
  .services-text {
    color: #333;
  }
  
  @media (max-width: 768px) {
    font-size: 48px;
  }
`;

const ServicesList = styled.div`
  display: flex;
  flex-direction: column;
`;

const ServiceItem = styled.div`
  border-bottom: 1px solid #e0e0e0;
  padding: 20px 0;
`;

const ServiceHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
`;

const ServiceNumber = styled.span`
  font-size: 18px;
  font-weight: 600;
  color: #666;
  margin-right: 20px;
  min-width: 40px;
`;

const ServiceName = styled.h3`
  font-size: 24px;
  font-weight: bold;
  color: ${props => props.$isActive ? '#3858F9' : '#333'};
  transition: color 0.3s ease;
  flex-grow: 1;
  
  @media (max-width: 768px) {
    font-size: 20px;
  }
`;

const ToggleIcon = styled.span`
  font-size: 24px;
  color: #666;
  transition: transform 0.3s ease;
  transform: ${props => props.$isActive ? 'rotate(180deg)' : 'rotate(0)'};
`;

const ServiceContent = styled.div`
  max-height: ${props => props.$isActive ? '1000px' : '0'};
  visibility: ${props => props.$isActive ? 'visible' : 'hidden'};
  transition: all 0.5s ease-in-out;
  opacity: ${props => props.$isActive ? '1' : '0'};
  margin-top: ${props => props.$isActive ? '20px' : '0'};
  display: flex;
  flex-wrap: wrap;
  
  @media (max-width: 768px) {
    flex-direction: column;
  }
`;

const ServiceDescription = styled.div`
  flex: 2;
  padding-right: 30px;
  padding-left: 60px;
  
  @media (max-width: 768px) {
    flex: 1;
    padding-right: 0;
    margin-bottom: 20px;
  }
`;

const ServiceTitle = styled.h4`
  font-size: 28px;
  font-weight: bold;
  color: #3858F9;
  margin-bottom: 20px;
  
  @media (max-width: 768px) {
    font-size: 24px;
  }
`;

const ServiceText = styled.p`
  font-size: 16px;
  line-height: 1.7;
  color: #555;
  margin-bottom: 24px;
`;

const ConsultationButton = styled.button`
  display: inline-flex;
  align-items: center;
  background: transparent;
  color: #3858F9;
  font-weight: bold;
  text-transform: uppercase;
  border: 1px solid #3858F9;
  padding: 12px 20px;
  border-radius: 4px;
  transition: all 0.3s;
  cursor: pointer;
  text-decoration: none;
  margin-top: 20px;
  
  &:hover {
    background-color: #3858F9;
    color: white;
    transform: translateY(-3px);
  }
  
  svg {
    margin-left: 10px;
  }
`;

// RTL version of Consultation Button with left-positioned arrow
const RtlConsultationButton = styled.button`
  position: relative;
  display: inline-block;
  background: transparent;
  color: #3858F9;
  font-weight: bold;
  text-transform: uppercase;
  border: 1px solid #3858F9;
  padding: 12px 20px 12px 56px; /* Extra padding on left for arrow */
  border-radius: 4px;
  transition: all 0.3s;
  font-size: 14px;
  text-decoration: none;
  cursor: pointer;
  margin-top: 20px;
  
  &:hover {
    background-color: #3858F9;
    color: white;
    transform: translateY(-3px);
  }
  
  svg {
    position: absolute;
    left: 20px;
    top: 50%;
    transform: translateY(-50%);
  }
  
  svg {
    margin-left: 10px;
  }
`;

const ServiceImageContainer = styled.div`
  flex: 1;
  display: flex;
  gap: 20px;
  
  @media (max-width: 768px) {
    flex: 1;
    flex-direction: column;
  }
`;

const ServiceImage = styled.img`
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
`;

// Function to get service data with translations
const getServicesData = (t) => [
  {
    id: 1,
    number: '1',
    name: t('home.services.items.1.name'),
    description: t('home.services.items.1.description'),
    image1: cosmeticDentalTreatment,
  },
  {
    id: 2,
    number: '2',
    name: t('home.services.items.2.name'),
    description: t('home.services.items.2.description'),
    image1: therapeuticOrthodontics,
  },
  {
    id: 3,
    number: '3',
    name: t('home.services.items.3.name'),
    description: t('home.services.items.3.description'),
    image1: TherapeuticAndCosmetic,
  },
  {
    id: 4,
    number: '4',
    name: t('home.services.items.4.name'),
    description: t('home.services.items.4.description'),
    image1: endodonticTreatment,
  },
  {
    id: 5,
    number: '5',
    name: t('home.services.items.5.name'),
    description: t('home.services.items.5.description'),
    image1: prosthesesInstallation,
  },
  {
    id: 6,
    number: '6',
    name: t('home.services.items.6.name'),
    description: t('home.services.items.6.description'),
    image1: pediatricServices,
  },
  {
    id: 7,
    number: '7',
    name: t('home.services.items.7.name'),
    description: t('home.services.items.7.description'),
    image1: teethImplantation,
  },
];

const Services = ({ id }) => {
  const { t, i18n } = useTranslation();
  const [activeService, setActiveService] = useState(null);
  
  // Get localized service data
  const servicesData = getServicesData(t);
  
  const toggleService = (id) => {
    setActiveService(activeService === id ? null : id);
  };

  // Open WhatsApp chat
  const openWhatsAppChat = (e) => {
    e.preventDefault();
    window.open('https://wa.me/966558507990', '_blank');
  };
  
  return (
    <ServicesSection id={id}>
      <Container>
        <ServicesTitle $dir={i18n.dir()}>
          <span className="our-text">{t('home.services.title.our')}</span> <span className="services-text">{t('home.services.title.services')}</span>
        </ServicesTitle>
        
        <ServicesList>
          {servicesData.map((service) => (
            <ServiceItem key={service.id}>
              <ServiceHeader onClick={() => toggleService(service.id)}>
                <ServiceNumber>{service.number}</ServiceNumber>
                <ServiceName $isActive={activeService === service.id}>
                  {service.name}
                </ServiceName>
                <ToggleIcon $isActive={activeService === service.id}>
                  {activeService === service.id ? '↑' : '↓'}
                </ToggleIcon>
              </ServiceHeader>
              
              <ServiceContent $isActive={activeService === service.id}>
                <ServiceDescription>
                  <ServiceTitle>{service.title}</ServiceTitle>
                  <ServiceText>{service.description}</ServiceText>
                  {i18n.language === 'ar' ? (
                    <RtlConsultationButton onClick={openWhatsAppChat}>
                      <svg 
                        width="16" 
                        height="16" 
                        viewBox="0 0 24 24" 
                        fill="none" 
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <line x1="19" y1="12" x2="5" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        <polyline points="12 5 5 12 12 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                      </svg>
                      {t('home.services.consultation')}
                    </RtlConsultationButton>
                  ) : (
                    <ConsultationButton onClick={openWhatsAppChat}>
                      {t('home.services.consultation')}
                      <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <line x1="5" y1="12" x2="19" y2="12"></line>
                        <polyline points="12 5 19 12 12 19"></polyline>
                      </svg>
                    </ConsultationButton>
                  )}
                </ServiceDescription>
                
                <ServiceImageContainer>
                  <ServiceImage 
                    src={service.image1} 
                    alt={`${service.name} - ${i18n.language === 'en' ? 'National Medical Elite dental services' : 'خدمات عيادة النخبة الوطنية الطبية'}`}
                    data-alt-key={`services.items.${service.id}.alt`}
                    data-alt-en={`${service.name} - National Medical Elite dental services`}
                    data-alt-ar={`${service.name} - خدمات عيادة النخبة الوطنية الطبية`}
                  />
                </ServiceImageContainer>
              </ServiceContent>
            </ServiceItem>
          ))}
        </ServicesList>
      </Container>
    </ServicesSection>
  );
};

export default Services;
